import SearchCard from "components/Card/SearchCard";
import AnimatedDialogLayout from "./AnimatedDialogLayout";
import useProperties from "hooks/useProperties";

const PropertyPopup = ({
  popupType,
  backdropStyle,
  isOrganisePage = false,
}) => {
  const { setSelectedPropertyPopup, selectedPropertyPopup } = useProperties();

  return (
    <AnimatedDialogLayout
      isOpen={
        selectedPropertyPopup.id === popupType && selectedPropertyPopup.property
      }
      onClose={() =>
        selectedPropertyPopup === popupType &&
        setSelectedPropertyPopup({ id: null, property: null })
      }
      styleDropdown={{ padding: 0 }}
      backdropStyle={backdropStyle}
    >
      {selectedPropertyPopup.id !== null &&
        selectedPropertyPopup.property !== null && (
          <SearchCard
            property={selectedPropertyPopup.property}
            isMapProperty={true}
            isOrganisePage={isOrganisePage}
          />
        )}
    </AnimatedDialogLayout>
  );
};

export default PropertyPopup;
